import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=72bcf295&scoped=true&"
import script from "./SettingsPage.vue?vue&type=script&lang=ts&"
export * from "./SettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=72bcf295&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bcf295",
  null
  
)

export default component.exports